"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _universalCookie = _interopRequireDefault(require("universal-cookie"));
var _reactIntl = require("react-intl");
var _DefaultLoading = _interopRequireDefault(require("./components/DefaultLoading"));
var _DefaultTranslateButton = _interopRequireDefault(require("./components/DefaultTranslateButton"));
var _index = require("../index");
var _config = require("../../config");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var GoogleTranslate = function GoogleTranslate(props) {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    displayTranslatedText = _useState2[0],
    setDisplayTranslatedText = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    inProgress = _useState4[0],
    setInProgress = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    originalText = _useState6[0],
    setOriginalText = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    translatedText = _useState8[0],
    setTranslatedText = _useState8[1];
  var intl = props.intl;
  (0, _react.useEffect)(function () {
    setOriginalText(props.text);
  }, []);
  var translate = function translate() {
    if (!displayTranslatedText) {
      if (!translatedText) {
        setInProgress(true);
        // Initialize the google translate api
        var googleTranslate = require("google-translate")(_config.GOOGLE_TRANSLATE_API_KEY);
        // Get current user locale from cookie or from the browser default language
        var cookies = new _universalCookie.default();
        var locale = cookies.get('pll_language') || navigator.language;
        // Make a request to google translate api
        googleTranslate.translate(originalText, locale, function (err, translation) {
          if (translation && translation.translatedText) {
            setTranslatedText(translation.translatedText);
            setDisplayTranslatedText(true);
          }
          setInProgress(false);
        });
      } else {
        setDisplayTranslatedText(true);
      }
    } else {
      setDisplayTranslatedText(false);
    }
  };
  var TranslateButton = function TranslateButton() {
    var ButtonComponent = props.translateButton;
    return /*#__PURE__*/_react.default.createElement(ButtonComponent, {
      onClick: translate,
      inProgress: inProgress,
      showTranslateTextLabel: intl.formatMessage({
        id: 'Voir la traduction',
        defaultMessage: 'Voir la traduction'
      }),
      showDefaultTextLabel: intl.formatMessage({
        id: 'Voir default text',
        defaultMessage: 'Voir default text'
      }),
      displayTranslateText: displayTranslatedText
    });
  };
  var Loading = function Loading() {
    var LoadingComponent = props.loading;
    // We use this component to display loading instead of text when we make a request
    return /*#__PURE__*/_react.default.createElement(LoadingComponent, {
      inProgress: inProgress
    });
  };
  var text = displayTranslatedText ? translatedText : originalText;
  return props.children({
    text: text,
    TranslateButton: TranslateButton,
    Loading: inProgress ? Loading : null
  });
};
GoogleTranslate.defaultProps = {
  translateButton: _DefaultTranslateButton.default,
  loading: _DefaultLoading.default
};
var _default = (0, _reactIntl.injectIntl)(GoogleTranslate);
exports.default = _default;